import greenUrl from '../assets/images/backgrounds/green.png';
import greyUrl from '../assets/images/backgrounds/grey.png';
import orangeUrl from '../assets/images/backgrounds/orange.png';
import purpleUrl from '../assets/images/backgrounds/purple.png';

import mainDarkGreen from '../assets/images/cups/main-cup-dark-green.png';
import mainLightGreen from '../assets/images/cups/main-cup-light-green.png';
import mainRed from '../assets/images/cups/main-cup-red.png';
import straightBlue from '../assets/images/cups/straight-cup-blue.png';
import straightDarkGreen from '../assets/images/cups/straight-cup-dark-green.png';
import straightLightGreen from '../assets/images/cups/straight-cup-light-green.png';
import straightRed from '../assets/images/cups/straight-cup-red.png';
import thinDarkGreen from '../assets/images/cups/thin-cup-dark-green.png';
import thinLightGreen from '../assets/images/cups/thin-cup-light-green.png';
import thinRed from '../assets/images/cups/thin-cup-red.png';
import white from '../assets/images/cups/white-cups.png';
import scanner from '../assets/images/scanner.png';
import drag from '../assets/images/bulk-edit/drag-img.png';
import fullCup from '../assets/images/fullCup.png';
import poster from '../assets/images/posters/import-listings.png';

export const cardBadges = [
  'rectangle',
  'ellipse',
  'flag',
];

export const cardBackgrounds = [
  orangeUrl,
  purpleUrl,
  greyUrl,
  greenUrl,
];

export const cardImages = [
  mainDarkGreen,
  mainLightGreen,
  mainRed,
  straightBlue,
  straightDarkGreen,
  straightLightGreen,
  straightRed,
  thinDarkGreen,
  thinLightGreen,
  thinRed,
  white,
  scanner,
  drag,
  fullCup,
  poster,
];

export const cardsCopyStack = [
  {
    productImage: {
      src: mainDarkGreen,
      alt: 'Cup Dark Green',
    },
    channels: ['vela', 'etsy'],
    price: '15.95',
    title: 'Coffee Mug',
  },
  {
    productImage: {
      src: mainDarkGreen,
      alt: 'Cup Dark Green',
    },
    channels: ['vela', 'shopify'],
    price: '15.95',
    title: 'Coffee Mug',
  },
];

export const colors = ['#269B8A', '#b23665', '#76E4BA'];
